<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Return Pending Report</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <img id="logoId" src="../../../public/images/logo.png" style="width:40px; height:40px; display:none;">
                    </div><!-- /.col -->
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="contact">Mobile No</label>
                                            <input type="text" id="contact" class="form-control" placeholder="Mobile no" v-model="search.contact">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="tracking_id">{{ $t('globalTrans.order_id') }}</label>
                                            <input type="text" id="tracking_id" class="form-control" placeholder="Order ID" v-model="search.order_id">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="coverage_area_id">Coverage Area</label>                                                
                                            <v-select name="coverage_area_id"
                                                multiple
                                                v-model="search.coverage_area_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= commonObj.coverageAreaList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2"  v-if="authUser.role_id != 7">
                                        <div class="form-group">
                                            <label for="source_hub_id">Source Hub</label>
                                            <v-select name="source_hub_id"
                                                v-model="search.source_hub_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= commonObj.hubList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2" v-if="authUser.role_id != 7">
                                        <div class="form-group">
                                            <label for="destination_hub_id">Destination Hub</label>
                                            <v-select name="destination_hub_id"
                                                multiple
                                                v-model="search.destination_hub_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= commonObj.hubList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="zonal_id">Zonal</label>
                                            <v-select name="zonal_id"
                                                multiple
                                                v-model="search.zonal_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= commonObj.zonalList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>  
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="date_parameter_id">Date Parameter</label>
                                            <select id="date_parameter_id" v-model="search.date_parameter_id" class="form-control">                                            
                                                <option v-for="(item, index) in customState.dateParameterList" :value="item.id" :key="index">{{ item.text }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="start_date">Start Date</label>
                                            <input type="date" id="start_date" v-model="search.start_date" class="form-control">                                                
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="end_date">End Date</label>
                                            <input type="date" id="end_date" v-model="search.end_date" class="form-control">                                                
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="date">{{ $t('globalTrans.status') }}</label>
                                            <v-select name="status"
                                                multiple
                                                v-model="search.status"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= statusList
                                                :placeholder="$t('globalTrans.select')"
                                            /> 
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <div class="form-group d-flex align-items-center gap-2" style="margin-top:28px;">
                                            <button class="btn btn-info btn-sm mr-1" type="submit" @click.prevent="searchData">
                                                <i class="fa fa-search"></i> Filter
                                            </button>

                                            <button class="btn btn-warning btn-sm mr-1" @click.prevent="reload">
                                                <i class="fa fa-sync-alt"></i>
                                            </button>

                                            <button class="btn btn-success btn-sm mr-1" type="button" @click.prevent="excelDownload">
                                                <i class="fa fa-download"></i> Excel
                                            </button>

                                            <p class="p-0 m-0 font-weight-bold" style="font-size:16px;">
                                                Total Order: {{ totalOrder }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <b-overlay :show="loading">
                                    <div class="table-responsive">
                                        <div style="width:100%; overflow-x:auto;">
                                            <table class="table table-bordered table-striped table-sm" id="orderTable">
                                                <thead>
                                                    <tr class="text-center">
                                                        <th style="width:13%">{{ $t('globalTrans.order_id') }}</th>
                                                        <th>{{ $t('globalTrans.merchant') }}</th>
                                                        <th>{{ $t('globalTrans.customer') }}</th>
                                                        <th>{{ $t('globalTrans.address') }}</th>
                                                        <th>Status</th>  
                                                        <th>{{ $t('globalTrans.date') }}</th>
                                                        <th>{{ $t('globalTrans.price') }}</th>
                                                        <th>{{ $t('globalTrans.collected') }}</th>
                                                        <th>Source to Destination</th>
                                                        <th>Rider</th>
                                                        <th>Resend ID</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(order,key) in listData" :key="key" class="text-center">
                                                        <td class="order-id">{{ order.id }}</td>
                                                        <td @click="orderLog(order.logs)">{{ order.merchant ? order.merchant.business : '' }}</td>
                                                        <td>{{ order.name }}, {{ order.mobile }}{{ order.mobile_2 ? ', '+ order.mobile_2 : '' }}</td>
                                                        <td>{{ order.address }}</td>
                                                        <td><span :class="'status-'+order.status">{{ getStatus(order.status) }} </span></td>                                    
                                                        <td>{{ order.date }}</td>
                                                        <td>{{ order.price }}</td>
                                                        <td>{{ order.collected }}</td>
                                                        <td>{{ order.source ? order.source.name : '' }} to {{ order.destination ? order.destination.name : '' }}</td>
                                                        <td v-html="order.rider 
                                                            ? `${order.rider.name}<br/>${order.rider.mobile}` 
                                                            : ''">
                                                        </td>
                                                        <td>{{ getOldAndNewId(order) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>  
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <b-pagination
                                            v-model="pagination.currentPage"
                                            :per-page="pagination.perPage"
                                            :total-rows="pagination.totalRows"
                                            @input="searchData"
                                        />
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <div v-if="orderLogModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header bg-info text-white">
                      <h5 class="modal-title text-center w-100">Order Log</h5>
                      <button type="button" class="close" aria-label="Close" @click="cancelModal">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <table class="table table-bordered table-sm">
                          <tr>
                              <th style="width:30%">Action By</th>
                              <th>Action</th>
                              <th>Date & Time</th>
                          </tr>
                          <tr v-for="(log, index) in order_logs" :key="index">
                              <td>{{ log.operation_by }}</td>
                              <td>{{ log.operation }}</td>
                              <td>{{ log.created_at | dateformat }} at {{ log.created_at | timeformat }}</td>
                          </tr>
                      </table>                      
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-danger" @click="cancelModal">Cancel</button>
                  </div>
              </div>
          </div>
        </div>
    </div>
</template>
<script>
    import config from '@/config' 
    import moment from 'moment'    
    
    export default {
        name:'ReturnPendingReport',
        data () {
            return {            
                loading: false,                 
                orderLogModal: false, 
                allSelected: false,                
                actionPanelModal:false,
                isExcelDownload: false,
                isScan: false,
                totalSelected: 0,
                totalOrder: 0,
                spinner: true,
                orders: [],
                orderId: '',
                search: {
                    merchant_id: '',
                    order_id: '',
                    contact: '',
                    ref_id: '',
                    status: '',
                    coverage_area_id: '',
                    source_hub_id: '',
                    destination_hub_id: '',
                    zonal_id: '',
                    date_parameter_id : 2,
                    start_date: moment().subtract(7,'d').format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD')
                },
                orderList: [],
                ordersData: [],
                order_ids: [],
                order_logs: [],
                printorders:[],
                bulk:{
                    order_ids: [],
                    status: ''
                },
                barcode:{
                    sku: ''
                },
                page: 1,
                key:'',
                buttonName:'',
                takeActionStatusList: [],
                statusList: [
                    { id:15, text: 'Partial Delivered'},
                    { id:19, text: 'Exchange'},
                    { id:20, text: 'Cancel'},
                    { id:21, text: 'On way to RTM'},
                    { id:22, text: 'Received by RTM'},
                    { id:23, text: 'On way to Source HUB'},
                    { id:24, text: 'Return Recevied by Source HUB'},
                    { id:25, text: 'Return On way to Merchant'}
                ],
                pagination: {
                    currentPage: 1,
                    totalRows: 0,
                    perPage: this.$store.state.commonObj.perPage,
                    slOffset: 1
                }
            }
        },
        created () {
            this.loadData() 
        },
        computed : {
            authUser () {
                return this.$store.state.authUser
            },
            stateReload () {
                return this.$store.state.stateReload
            },
            commonObj () {
                return this.$store.state.commonObj
            },
            customState () {
                return this.$store.state
            },
            listData () {
                return this.$store.state.list
            },
        },
        methods:{
            searchData () {
                this.page = 1
                this.totalOrder = 0
                this.orders = []
                this.loadData()
            },
            async excelDownload () {
                this.loading = true
                try {
                    const response = await config.getFile('excel-download/return-report', this.search)
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'ReturnPendingReport.csv')
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    window.URL.revokeObjectURL(url)
                } catch (error) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, something went wrong',
                        color: '#dc3545'
                    })
                }
                this.loading = false
            },
            async loadData(){       
                this.loading = true 
                const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })       
                const response = await config.getData('/report/return-pending-report', params)
                this.loading = false
                if (response.success) {
                    this.$store.dispatch('setList', response.data.data)
                    this.paginationData(response.data)
                    this.totalOrder = response.data.total
                } else {
                    this.$store.dispatch('setList', [])
                }
            },
            paginationData (data) {
                this.pagination.currentPage = data.current_page
                this.pagination.totalRows = data.total
                this.pagination.perPage = data.per_page
                this.pagination.slOffset = this.pagination.perPage * this.pagination.currentPage - this.pagination.perPage + 1
            },
            orderLog (logs) {
                this.order_logs = logs 
                this.orderLogModal = true
            },
            cancelModal () {
                this.barcode.sku = this.bulk.status = ''
                this.printorders = this.bulk.order_ids = this.orderList = this.takeActionStatusList = []  
                this.totalOrder = 0
                this.allSelected =  this.orderLogModal = this.actionPanelModal = false
            },
            getStatus (status) {
                const tmpStatus = this.$store.state.statusList.find(item => item.id == status)
                return typeof tmpStatus !== 'undefined' ? tmpStatus.text : ''
            },
            reload () {
                this.totalOrder = 0
                this.search = Object.assign({}, {
                    merchant_id: '',
                    order_id: '',
                    contact: '',
                    ref_id: '',
                    status: '',
                    source_hub_id: '',
                    destination_hub_id: '',
                    start_date: moment().subtract(30,'d').format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD')
                })
            },
            getOldAndNewId (order) {
                if(order.pathao_id) {
                    return 'Old Id: '+ order.pathao_id;
                } else if (order?.details?.new_id) {
                    return 'New Id: '+ order.details.new_id;
                }
                return '';
            }
        },
    }
</script>
